import { useEffect, useState } from "react";
import { adminGet } from "@/lib/adminApi";
import { PILLAR_LABELS } from "@/lib/instant";

export default function Stats() {
  const [d, setD] = useState(null);
  useEffect(() => {
    adminGet("/stats").then(setD).catch(() => {});
  }, []);
  if (!d) return <p className="rav-page-sub">Chargement des statistiques…</p>;

  const bars = (list, labels) => {
    const max = Math.max(1, ...list.map(([, v]) => v));
    return list.map(([k, v]) => (
      <div key={k} className="rav-bar-row">
        <span className="rav-bar-label">{labels?.[k] || k}</span>
        <span className="rav-bar-track">
          <span className="rav-bar-fill" style={{ width: `${(v / max) * 100}%` }} />
        </span>
        <span className="rav-bar-value">{v}</span>
      </div>
    ));
  };

  const cards = [
    ["Comptes", d.users_total],
    ["Instants (total)", d.instants_total],
    ["Instants (7 jours)", d.instants_7d],
    ["Instants (30 jours)", d.instants_30d],
    ["Minutes pratiquées", d.minutes_total],
    ["Rendez-vous", d.rdv_total],
    ["Revenus visio (€)", d.rdv_revenue],
    ["Inscrites à la lettre", d.newsletter_count],
  ];

  return (
    <div data-testid="admin-stats-module">
      <h2 className="rav-admin-h2">Statistiques détaillées</h2>
      <div className="rav-admin-grid">
        {cards.map(([label, value]) => (
          <div key={label} className="rav-admin-card" data-testid={`stat-${label}`}>
            <div className="rav-admin-card-value">{value}</div>
            <div className="rav-admin-card-label">{label}</div>
          </div>
        ))}
      </div>

      <h2 className="rav-admin-h2">Piliers pratiqués</h2>
      {bars(d.by_pillar, PILLAR_LABELS)}

      <h2 className="rav-admin-h2">Ressentis au départ</h2>
      {bars(d.by_feeling)}

      <h2 className="rav-admin-h2">Ressentis après l'Instant</h2>
      {d.by_feeling_after.length === 0 ? <p className="rav-page-sub">Pas encore de ressentis partagés.</p> : bars(d.by_feeling_after)}

      <h2 className="rav-admin-h2">Demandes par statut</h2>
      {d.requests_by_status.length === 0 ? <p className="rav-page-sub">Aucune demande.</p> : bars(d.requests_by_status)}

      <h2 className="rav-admin-h2">Instants par jour (30 derniers jours)</h2>
      {d.instants_per_day.length === 0 ? <p className="rav-page-sub">Aucune activité.</p> : bars(d.instants_per_day)}
    </div>
  );
}
